// extracted by mini-css-extract-plugin
module.exports = {"landingFeatures":"LandingFeatures_landingFeatures__3Q7Kh","features":"LandingFeatures_features__12OjN"};